import { render } from "./CustomerInfoForm.vue?vue&type=template&id=a5d484b6&scoped=true"
import script from "./CustomerInfoForm.vue?vue&type=script&lang=js"
export * from "./CustomerInfoForm.vue?vue&type=script&lang=js"

import "./CustomerInfoForm.vue?vue&type=style&index=0&id=a5d484b6&lang=scss"
import "./CustomerInfoForm.vue?vue&type=style&index=1&id=a5d484b6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d484b6"]])

export default __exports__